import ellaGenericDefaults from '../shopify-ella-generic/config.js';

const ignoreFields = [...ellaGenericDefaults.Widgets.find((w) => w.name === 'Facets').ignoreFields];

export default {
  includes: ['shopify-ella-generic'],
  ...ellaGenericDefaults,
  facets: {
    rangedFacet: [{ fields: ['wheel_bore'], step: '1/10//1', slider: { mode: 'LowerBound' } }],
  },
  Widgets: [
    ...ellaGenericDefaults.Widgets.filter((w) => w.name !== 'FacetDialog'),
    {
      name: 'FacetDialog',
      template: 'FacetDialogVehicleSpecs',
      ignoreFields,
      initCollapsed: false,
    },
  ],
};
